import { createFileRoute } from '@tanstack/react-router'
import { parse } from 'valibot'

import { fetchArea, fetchAreas } from '@/features/areas/api'

import { areaParamsSchema } from './-models/area-params'
// エリアマスタ
export const Route = createFileRoute(
  '/_protected/$tenantKey/settings/_system-master-settings/areas/$areaId'
)({
  parseParams: (params) => parse(areaParamsSchema, params),
  loader: async ({
    abortController,
    params: { tenantKey, areaId },
    context: { auth }
  }) => {
    const [area, areaSelectList] = await Promise.all([
      fetchArea({ tenantKey, areaId }, abortController.signal),
      fetchAreas({ tenantKey }, abortController.signal)
    ])

    return {
      authUser: auth.user,
      area,
      areaSelectList
    }
  },
  meta: ({ loaderData }) => [
    {
      title: loaderData.area.name
    }
  ]
})
